import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { useMenuConfig } from './useMenuConfig'

const itemStyles = css`
  display: block;
  outline: none;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  cursor: default;
  padding: 10px 4px;
  width: 100%;
  text-align: left;
  text-decoration: none;
  line-height: 1;
  color: ${(p) => p.theme.text};

  &:disabled {
    background-color: transparent;
    color: ${(p) => p.theme.disabledText};
  }

  &:active,
  &.active {
    background-color: ${(p) => p.theme.highlight};
  }

  &:not(:disabled, .active, :active) {
    &:focus {
      background-color: transparent;
      color: ${(p) => p.theme.text};
    }

    &[data-selected],
    &:hover {
      background-color: ${(p) => p.theme.hover};
      cursor: pointer;
      color: ${(p) => p.theme.text};
    }
  }

  &.active {
    background-color: ${(p) => p.theme.highlight};
    color: ${(p) => p.theme.invertedText};
  }
`

const ItemLink = styled(NavLink)`
  ${itemStyles};
`

const ItemButton = styled.button`
  ${itemStyles}
`

const Contents = styled.div<{ $hasLeftSideSpace?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 4px;
  padding-left: ${(p) => (p.$hasLeftSideSpace ? 0 : '4px')};
  line-height: 1;
`
const CheckboxArea = styled.span`
  display: inline-block;
  width: 12px;
  height: 16px;
  line-height: 1;
`
const LabelArea = styled.div<{ $hasCheckbox?: boolean }>`
  padding-left: ${(p) => (p.$hasCheckbox ? '8px' : 0)};
  line-height: 1;
`
const Label = styled.div`
  line-height: 1;
`
const Note = styled.div`
  line-height: 1;
`
// const checkmarks = '☑️✔️✅✓✔︎'
// const chevrons =  '› ›‹'

const MenuItem = (props) => {
  const {
    to,
    onClick,
    disabled,
    children,
    label,
    checked,
    note,
    ellipsis,
    onSelect,
    isOpen,
    onOpen,
    onClose,
    ...rest
  } = props

  const $onClick = onClick || onSelect || onOpen

  const { onClose: onMenuClose, hasLeftSideSpace } = useMenuConfig()

  const handleClick = (event) => {
    if (!disabled) $onClick(event)

    onMenuClose()
  }

  const renderProps = {
    disabled: disabled || (!$onClick && !to),
    onClick: handleClick,
  }

  const $label = label || children || '[ Menu Item ]'

  const noEllipsis = _.has(props, 'ellipsis') && !ellipsis

  const $ellipsis =
    (ellipsis || _.has(props, 'onOpen')) && !noEllipsis ? '…' : null

  const displayLabel = (
    <Label>
      {$label}
      {$ellipsis}
    </Label>
  )

  const displayNote = note && <Note>{note}</Note>

  const contents = (
    <Contents $hasLeftSideSpace={hasLeftSideSpace}>
      {hasLeftSideSpace && <CheckboxArea>{checked ? '›' : ''}</CheckboxArea>}

      <LabelArea $hasCheckbox={hasLeftSideSpace}>
        {displayLabel}
        {displayNote}
      </LabelArea>
    </Contents>
  )

  if (to) {
    return (
      <ItemLink to={to} {...renderProps} {...rest}>
        {contents}
      </ItemLink>
    )
  } else {
    return (
      <ItemButton {...renderProps} {...rest}>
        {contents}
      </ItemButton>
    )
  }
}

export default MenuItem
